export const ActivityFeed = () => {
  // Dummy activity feed data – replace with real-time data as needed.
  const activities = [];

  return (
    <div className="bg-[#1E555C] shadow rounded-3xl p-4 transform hover:scale-105 transition duration-300 ease-in-out">
      <div className="text-xl font-bold text-gray-200 mb-4">Recent Activity</div>
      <ul className="text-gray-300 text-sm space-y-2">
        {activities && <>No recent activity</>}
        {activities.map((item, index) => (
          <li key={index} className="border-b border-[#545a6f] pb-2">
            <span className="text-xs text-gray-400">{item.time}</span>
            <p>{item.activity}</p>
          </li>
        ))}
      </ul>
    </div>
  );
};
